<div class="fixed inset-0 bg-black bg-opacity-50 overflow-y-auto h-full w-full" style="z-index: 2000;" id="modal-backdrop">
  <ng-content></ng-content>
</div>
